export const formatProduct = (product) => {
    const productMap = {
        'CNC': 'Overnight',
        'NRML': 'Overnight',
        'MIS': 'Intraday',
        'CNC/NRML': 'Overnight',
    };
    return productMap[product] || product;
};

export const getOrderStatusColor = (status) => {
    const statusColorMap = {
        'COMPLETE': 'success.main',
        'CANCELLED': 'error.main',
        'CANCEL_CONFIRMED': 'error.main',
        'REJECTED': 'error.main',
        'PENDING': 'warning.main',
        'EXCHANGE_RESPONSE_PENDING': 'warning.main',
        'OPEN': 'warning.main',
        'PARTIALLY_EXECUTED': 'warning.main',
        'CONFIRMED': 'warning.main'
    };

    return statusColorMap[status] || 'text.secondary';
};

export const getMarginType = (product) => {
    const marginTypeMap = {
        'CNC': 'Overnight',
        'NRML': 'Overnight',
        'MIS': 'Intraday',
    };
    return marginTypeMap[product] || 'overnight';
};

export const shouldHidePercentage = (exchange) => {
    // Hide percentage for DCSX exchange (code 19)
    return exchange === 19;
};

export const getValueColor = (value, specialKeys = []) => {
    const numValue = parseFloat(value);
    if (specialKeys?.includes(value)) {
        return 'success.main';
    }

    if (isNaN(numValue)) {
        return 'text.primary'; // Default color for non-numeric values
    }

    if (numValue > 0) {
        return 'success.main'; // Positive values in green
    } else if (numValue < 0) {
        return 'error.main'; // Negative values in red
    }
    return 'text.primary'; // Zero or neutral values in default color
};


export const formatLastActivityTime = (nanoseconds) => {
    const milliseconds = Math.floor(nanoseconds / 1000000);
    return new Date(milliseconds).toLocaleTimeString("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
    });
};

export const getOrderType = (orderType) => {
    const orderTypeMap = {
        'MARKET': 'MARKET',
        'LIMIT': 'LIMIT',
        'SL': 'SL',
        'SLM': 'STOPLOSSMARKET',
    }
    return orderTypeMap[orderType] || orderType;
};

export const getProductType = (productType, exchnage,is_index=false) => {
    const productMap = {
        'MIS': "MIS",
        "CNC/NRML":(exchnage === "NSE" || exchnage === "BSE") && !is_index ? "CNC" : "NRML",
        "CNC": "CNC",
        "NRML": "NRML",
    }
    return productMap[productType];
};

/**
 * Formats a price with specified precision
 * @param {number|string} price - The price value to format
 * @param {number} precision - Number of decimal places to show (default: 2)
 * @param {object} options - Additional formatting options
 * @param {boolean} options.showCurrency - Whether to show currency symbol (default: false)
 * @param {string} options.currencySymbol - Currency symbol to use (default: '₹')
 * @param {boolean} options.showCommas - Whether to show thousand separators (default: false)
 * @param {boolean} options.removeTrailingZeros - Whether to remove trailing zeros (default: false)
 * @returns {string} Formatted price string
 */
export const formatPriceWithPrecision = (price, precision = 2, options = {}) => {
    const {
        showCurrency = false,
        currencySymbol = '₹',
        showCommas = false,
        removeTrailingZeros = false
    } = options;

    // Handle null, undefined, or empty values
    if (price === null || price === undefined || price === '' || price === 'N/A') {
        return showCurrency ? `${currencySymbol}0` : '0';
    }

    // Convert to number if it's a string
    const numericPrice = typeof price === 'string' ? parseFloat(price) : price;

    // Handle NaN or invalid numbers
    if (isNaN(numericPrice)) {
        return showCurrency ? `${currencySymbol}0` : '0';
    }

    // Format with specified precision
    let formattedPrice = numericPrice.toFixed(precision);

    // Remove trailing zeros if requested
    if (removeTrailingZeros && precision > 0) {
        formattedPrice = parseFloat(formattedPrice).toString();
    }

    // Add thousand separators if requested
    if (showCommas) {
        const parts = formattedPrice.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        formattedPrice = parts.join('.');
    }

    // Add currency symbol if requested
    if (showCurrency) {
        formattedPrice = `${currencySymbol}${formattedPrice}`;
    }

    return formattedPrice;
};

/**
 * Formats a price for Indian currency with appropriate precision
 * @param {number|string} price - The price value to format
 * @param {number} precision - Number of decimal places (default: 2)
 * @returns {string} Formatted price with ₹ symbol and commas
 */
export const formatIndianPrice = (price, precision = 2) => {
    return formatPriceWithPrecision(price, precision, {
        showCurrency: true,
        currencySymbol: '₹',
        showCommas: true,
        removeTrailingZeros: false
    });
};

/**
 * Formats a price for display in tables/lists (no currency symbol, with precision)
 * @param {number|string} price - The price value to format
 * @param {number} precision - Number of decimal places (default: 2)
 * @returns {string} Formatted price without currency symbol
 */
export const formatDisplayPrice = (price, precision = 2) => {
    return formatPriceWithPrecision(price, precision, {
        showCurrency: false,
        showCommas: false,
        removeTrailingZeros: true
    });
};


